import React, { useEffect, useState } from "react";
import { MDBCol, MDBRow } from "mdbreact";
import { Button, Text } from "evergreen-ui";
import { Input, Select } from "antd";
import { useListVals } from "../../../Firebase/databaseHooks";
import Firebase from "../../../Firebase/Firebase";
import { getDatabase, ref } from "firebase/database";
import { v4 as uuidv4 } from 'uuid';

const db = getDatabase(Firebase);
const CategoriesActionLayout = (props) => {

	const [name, setName] = useState(null);
	const [ID, setID] = useState(null);
	const [langArray] = useListVals(ref(db, "talmidsdb/languages"));
	const [selectedLang, setSelectedLang] = useState(null);

	const handleLang = (value) => {
		setSelectedLang(value);
	}

	function randomInteger(min, max) {
		return Math.floor(Math.random() * (max - min + 1)) + min;
	}

	const handleCreate = () => {

		if (name == null || ID == null) {

			alert("Fields cannot be left empty!");
		} else if (ID.includes("/")) {
			alert("The code cannot include a slash")
		} else {
			var objectID = uuidv4();
			var object = {
				"name": name,
				"id": objectID,
			}
			setName(null); setSelectedLang(null); setID(null);
			props.createCallback("categories", objectID, object);
		}
	}

	return (
		<div className="font-Nunito">
			<MDBRow>
				<MDBCol className="px-4">
					<div className="d-flex flex-column mt-3">
						<div className="d-flex flex-column">
							<Text className=" mb-1">Enter Category name</Text>
							<Input type="text"
								placeholder="enter category name"
								className="w-100 mr-4"
								onChange={(e) => { setName(e.target.value) }}
								value={name}
								id="email"
							/>
						</div>
						<div className="d-flex flex-column mt-3">
							<Text className=" mb-1">Enter Category code</Text>
							<Input type="text"
								placeholder="enter category code"
								className="w-100 mr-4"
								onChange={(e) => { setID(e.target.value) }}
								value={ID}
								id="email"
							/>
						</div>

						<div className="d-flex flex-column my-2">
							<Text className=" mb-1">Select Category Language</Text>
							<Select value={selectedLang} placeholder="Select Language" onChange={handleLang}>
								{langArray.map((item, index) => (
									<Select.Option value={item.id} key={index}>{item.languageName}</Select.Option>
								))}

							</Select>
						</div>

					</div>
					<Button appearance="primary" className="mt-3" onClick={() => {
						handleCreate();
					}}>Create</Button>

				</MDBCol>
			</MDBRow>
		</div>
	)

}

export default CategoriesActionLayout;
